import React, { SyntheticEvent, useEffect, useState } from "react";
import { Card, Icon, Image, Menu, Popup, Segment } from "semantic-ui-react";
import styles from "./card.module.css";
import { getScoreColor } from "./Functions/getScoreColor";
import recipientPhoto from "../../../../Images/Temporary/recipientPhoto.jpg";
import { IRecipientModel } from "../../../../Models/Recipient";
import { observer } from "mobx-react-lite";
import { trackPromise } from "react-promise-tracker";
import { useAgeReadyContext } from "../../../../AgeReadyContext/AgeReadyContext";

export enum settingsChoices {
  EDIT = "Edit",
  DELETE = "Delete",
}

interface IRecipientCardProps {
  recipient: IRecipientModel;
  selectedRecipient: IRecipientModel | undefined;
  onSelected: (recipient: IRecipientModel | undefined) => void;
  onEditClick: () => void;
  onDeleteClick: () => void;
}

const RecipientCard: React.FC<IRecipientCardProps> = (
  props: IRecipientCardProps
) => {
  const { recipient, selectedRecipient, onSelected, onEditClick, onDeleteClick } = props;
  const [recipientMenuVisible, setRecipientMenuVisible] = useState(false);
  const { partnerStore } = useAgeReadyContext();

  useEffect(() => {
    const loadLogo = async () => {
      await trackPromise(partnerStore.loadLogo(recipient?.imgUrl));
    }
    try {
      loadLogo();
    } catch (error) {
      // Image doesn't esists so it will load default image
      console.error('error', error);
    }
  }, [recipient.imgUrl,partnerStore])

  const getLogoByPartnerId = ( partnerId: string | undefined | null ): string | undefined => {
    if (!partnerId) {
      return undefined;
    }
    return partnerStore.logosByPartnerId.get(partnerId);
  }

  const selectRecipient = () => {
    if (selectedRecipient && selectedRecipient.id === recipient.id) {
      onSelected(undefined);
    } else {
      onSelected(recipient);
    }
  };
  
  const isOpaque = () => {
    if (selectedRecipient) {
      return selectedRecipient.id === recipient.id;
    } else {
      return true;
    }
  };

  const isSelected = () => {
    if (selectedRecipient) {
      return selectedRecipient.id === recipient.id;
    } else {
      return false;
    }
  };

  const recipientSettingsDropdownHandler = (e:SyntheticEvent, { value }:any) => { 
    switch(value)
    {
      case settingsChoices.EDIT:
        setRecipientMenuVisible(false);
        onEditClick();
        break;
      case settingsChoices.DELETE:
        setRecipientMenuVisible(false);
        onDeleteClick();
        break;
      default:
        setRecipientMenuVisible(false);
        break;
    }
  }
 
  const recipientSettingsOptions =  [
    { 
      key: settingsChoices.EDIT, 
      value: settingsChoices.EDIT, 
      content:(<span> <b>{settingsChoices.EDIT}</b> {recipient.firstName} {recipient.lastName} </span>) 
    },
    { 
      key: settingsChoices.DELETE, 
      value: settingsChoices.DELETE, 
      content:(<span> <b>{settingsChoices.DELETE}</b> {recipient.firstName} {recipient.lastName} </span>)},
  ]


  return (
    <>
      <Card
        fluid
        id="recipientCard"
        data-testid="enabled-card"
        className={styles.recipientCard}
        style={{
          textAlign: "center",
          backgroundColor: " #ffffff",
          filter: isSelected() ? "drop-shadow(0 0 0.1rem #00b5ad)" : "",
          opacity: isOpaque() ? "1" : "0.4",
          paddingBottom: "0px", 
          marginBottom: "0px",
          zIndex: isSelected() ? "1" : "auto",
        }}
      >
        <Card.Content style={{display: 'grid'}} >
          <Segment basic className={styles.settingsSection}  style={{marginTop: 0, marginBottom: '-.2rem', paddingTop: 0, paddingBottom: '.2rem'}}>
            <Card.Description className={styles.score} style={{ color: getScoreColor(recipient.overallScore), fontWeight: "bold", }} />
            {isSelected() && (<Popup         
              on='click' 
              position='left center'
              open={recipientMenuVisible}
              onOpen={() => setRecipientMenuVisible(true)}
              onClose={() => setRecipientMenuVisible(false)}
              trigger= {<div className={styles.settingsIconDiv}><Icon name="cog" size="big" className={styles.settingsSectionIcon}/></div>}    
            >
              <Menu
                items={recipientSettingsOptions}
                onItemClick={recipientSettingsDropdownHandler}
                secondary
                vertical
              />
            </Popup>
             )}
          </Segment>
          <Segment basic as="a" onClick={selectRecipient} style = {{display:"flex",flexDirection: 'column', alignItems:'center',alignContent:"space-between",justifyContent:"space-between",}}>
            <Image circular src={getLogoByPartnerId(recipient?.imgUrl)||recipientPhoto} className={styles.recipientPhoto}  />
            <Card.Description style={{ fontSize: "20pt", color: "#333B4C", fontWeight: "800", }} >
              {recipient.firstName} {recipient.lastName}
            </Card.Description>
          </Segment>
        </Card.Content>
      </Card>
    </>
  );
};

export default observer(RecipientCard);
